import React, { useState } from 'react'

import { ScrollableUserList } from 'components/UI'
import { t } from 'translations'
import { getUserName } from 'services/Utilities'

// Returns a loading component as well as a function to toggle it
const useProgress = defaultProgress => {
  const [progress, setProgress] = useState(defaultProgress)

  const ProgressComponent = () => {
    if (!progress) return null

    return (
      <div className="mt-3">
        <div className="progress">
          <div
            className={`progress-bar${progress.striped ? ' progress-bar-striped' : ''} ${progress.type} ${
              progress.hasFailedUsers ? 'bg-warning' : 'bg-success'
            }`}
            role="progressbar"
            style={{ width: `${progress.width}%` }}
            aria-valuenow={progress.width}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {progress.userId ? getUserName(progress.userId) : null}
            {progress.text ? progress.text : t('manager.users.bulkEdit.DONE')}
          </div>
        </div>
        {progress.failedUsers && progress.failedUsers.length ? (
          <div className="mt-3">
            <ScrollableUserList containerClass="card bg-light mb-3 text-danger" usersIds={progress.failedUsers} />
          </div>
        ) : null}
        {progress.children ? <div className="text-center">{progress.children}</div> : null}
      </div>
    )
  }

  return [ProgressComponent, progress, setProgress]
}

export default useProgress
